import { isEmpty, isNil } from 'lodash'

// =============================================================================
// locateSnippet — re-anchor a comment to its quoted text in the CURRENT text,
// version-agnostic. Offsets stored at create time drift when the surrounding
// text is edited, so the snippet is the source of truth and the stored offset
// is only a tie-breaker between repeated occurrences. Returns null when the
// snippet is absent — the caller treats that as orphaned (don't paint).
// =============================================================================

export const locateSnippet = (text, snippet, offsetHint = 0) => {
  if (isNil(text) || isEmpty(snippet)) {
    return null
  }

  const occurrences = []
  let from = 0
  let at = text.indexOf(snippet, from)
  while (at !== -1) {
    occurrences.push(at)
    from = at + 1
    at = text.indexOf(snippet, from)
  }
  if (isEmpty(occurrences)) {
    return null
  }

  const hint = isNil(offsetHint) ? 0 : offsetHint
  // Earliest occurrence on a distance tie (strict <), so it's deterministic.
  const start = occurrences.reduce((best, candidate) =>
    Math.abs(candidate - hint) < Math.abs(best - hint) ? candidate : best
  )
  return { start, end: start + snippet.length }
}
